import React from 'react';
import { Wrapper, Content, Controls, Header, UserInfo, InfoGroup } from './card-feedback-request.styles';
import { CardFeedbackRequestProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import dayjs from 'dayjs';
import { Photo } from '@shared/ui/photo/photo';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { FeedbackRequestStatusBadge } from '../feedback-request-status-badge/feedback-request-status-badge';
import { EntityRelatedUser } from '@shared/ui/entity-related-user/entity-related-user';

export const CardFeedbackRequest: React.FC<CardFeedbackRequestProps> = ({ feedbackRequest, children, ...props }) => {
    const clientName = userName({
        firstName: feedbackRequest.client?.firstName,
        lastName: feedbackRequest.client?.lastName,
        middleName: feedbackRequest.client?.middleName,
    });

    return (
        <Wrapper {...props}>
            <Header>
                <UserInfo>
                    <Photo size='s' photoUrl={feedbackRequest?.client?.photoUrl} name={clientName.full} />
                    <Typography size='subtitle2' color='neutral_90'>
                        {clientName.full || 'Пользователь удален'}
                    </Typography>
                </UserInfo>
                <Controls>{children}</Controls>
            </Header>
            <Content>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Тема обращения
                    </Typography>
                    <Typography size='body2_long'>{feedbackRequest.subjectTitle}</Typography>
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        ID обращения
                    </Typography>
                    <Typography size='body2_long'>{`№${feedbackRequest.id}`}</Typography>
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата создания
                    </Typography>
                    <Typography size='body2_long'>{dayjs(feedbackRequest.createdAt).format('DD.MM.YY')}</Typography>
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Работает с обращением
                    </Typography>
                    <EntityRelatedUser user={feedbackRequest.admin} nameType='short' />
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Статус
                    </Typography>
                    <FeedbackRequestStatusBadge status={feedbackRequest.status} />
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
